import DisabilitySelectionViewModel from "./DisabilitySelectionViewModel";

export default class EnrolmentFormViewModel {
    offeringId: string | undefined = undefined;
    enrolmentType: string | undefined = undefined;
    academicYearId: string | undefined = undefined;

    sex: string | undefined = undefined;
    title: string | undefined = undefined;
    firstForenames: string | undefined = undefined;
    otherForenames: string | undefined = undefined;
    surname: string | undefined = undefined;
    surnameAtBirth: string | undefined = undefined;
    dateofBirth: Date | undefined = undefined;
    mobilePhoneNumber: string | undefined = undefined;
    landlinePhoneNumber: string | undefined = undefined;
    email: string | undefined = undefined;
    nationalInsuranceNumber: string | undefined = undefined;
    postcode: string | undefined = undefined;
    postcodeOut: string | undefined = undefined;
    postcodeIn: string | undefined = undefined;
    contactFirstName: string | undefined = undefined;
    contactSurname: string | undefined = undefined;
    contactRelationship: number | undefined = undefined;
    contactLandlinePhoneNumber: string | undefined = undefined;
    contactMobilePhoneNumber: string | undefined = undefined;
    contactEmail: string | undefined = undefined;
    addressIndex: number | undefined = undefined;
    address1: string = '';
    address2: string = '';
    address3: string = '';
    address4: string = '';

    termTimeAddressIndex: number | undefined = undefined;
    termTimeAddress1: string = '';
    termTimeAddress2: string = '';
    termTimeAddress3: string = '';
    termTimeAddress4: string = '';
    termTimePostcode: string = '';
    termTimePostcodeOut: string = '';
    termTimePostcodeIn: string = '';
    termTimePhoneNumber: string | undefined = undefined;

    accommodationType: number | undefined = undefined;

    parent1Responsibility: boolean | undefined = undefined;
    parent1Title: string | undefined = undefined;
    parent1FirstName: string | undefined = undefined;
    parent1Surname: string | undefined = undefined;
    parent1MobTel: string | undefined = undefined;
    parent1HomeTel: string | undefined = undefined;
    parent1WorkTel: string | undefined = undefined;
    parent1EmailAddress: string | undefined = undefined;
    parent1LiveWithStudent: boolean | undefined = true;
    parent1AddressIndex: number | undefined = undefined;
    parent1Address1: string = '';
    parent1Address2: string = '';
    parent1Address3: string = '';
    parent1Address4: string = '';
    parent1Postcode: string = '';
    parent1PostcodeIn: string = '';
    parent1PostcodeOut: string = '';

    parent2Responsibility: boolean | undefined = undefined;
    parent2Title: string | undefined = undefined;
    parent2FirstName: string | undefined = undefined;
    parent2Surname: string | undefined = undefined;
    parent2MobTel: string | undefined = undefined;
    parent2HomeTel: string | undefined = undefined;
    parent2WorkTel: string | undefined = undefined;
    parent2EmailAddress: string | undefined = undefined;
    parent2LiveWithStudent: boolean | undefined = true;
    parent2AddressIndex: number | undefined = undefined;
    parent2Address1: string = '';
    parent2Address2: string = '';
    parent2Address3: string = '';
    parent2Address4: string = '';
    parent2Postcode: string = '';
    parent2PostcodeIn: string = '';
    parent2PostcodeOut: string = '';

    school: string | undefined = undefined;
    schoolAttendedFrom: Date | undefined = new Date(2019, 8, 1);
    schoolAttendedTo: Date | undefined = new Date(2020, 6, 31);
    priorAttainment: string | undefined = undefined;
    previousExamConcessions: boolean | undefined = undefined;

    gcseEnglishGrade: string | undefined = undefined;
    gcseEnglishGradeAskLevel2: boolean | undefined = undefined;
    englishFSQuestion: boolean | undefined = undefined;
    englishByEndOfYear11: boolean | undefined = undefined;

    gcseEnglishLitGrade: string | undefined = undefined;
    gcseEnglishLitGradeAskLevel2: boolean | undefined = undefined;
    englishLitFSQuestion: boolean | undefined = undefined;
    englishLitByEndOfYear11: boolean | undefined = undefined;

    gcseMathsGrade: string | undefined = undefined;
    gcseMathsGradeAskLevel2: boolean | undefined = undefined;
    mathsFSQuestion: boolean | undefined = undefined;
    mathsByEndOfYear11: boolean | undefined = undefined;

    occupation: string | undefined = undefined;
    heQuals: string | undefined = undefined;

    nationality: string | undefined = undefined;
    country: string | undefined = undefined;
    euroResident: boolean | undefined = undefined;
    euroResidentDate: Date | undefined = undefined;
    ethnicOrigin: string | undefined = undefined;
    firstLanguage: string | undefined = undefined;
    householdSituation: string | undefined = undefined;
    householdSituation2: string | undefined = undefined;
    armedForces: boolean | undefined = undefined;
    localAuthorityCare: boolean | undefined = undefined;
    careLeaver: boolean | undefined = undefined;
    youngCarer: boolean | undefined = undefined;
    freeSchoolMeals: boolean | undefined = undefined;
    previousFreeSchoolMeals: boolean | undefined = undefined;
    photoPermission1416: boolean | undefined = undefined;


    learningDifficultyDisabilityResponse: string | undefined = undefined;
    disabilitySelection: DisabilitySelectionViewModel[] = [];
    disabilitySelectionJSON: string = '';
    alsRequested: boolean | undefined = undefined;
    hasEHCP: boolean | undefined = undefined;
    medicalConditions: string | undefined = undefined;
    medication: string | undefined = undefined;


    employmentStatus: string | undefined = undefined;
    isSelfEmployed: boolean | undefined = undefined;
    employmentIntensity: string | undefined = undefined;
    employmentLength: string | undefined = undefined;
    unemploymentLength: string | undefined = undefined;
    employedFrom: Date | undefined = undefined;
    unemployedFrom: Date | undefined = undefined;
    fullTimeEducation: boolean| undefined = undefined;
    benifitsStatus: number | undefined = undefined;


    criminalConviction: boolean | undefined = undefined;

    feesAndFunding: string | undefined = undefined;
    feesAndFundingSource: string | undefined = undefined;

    ownTablet: boolean | undefined = undefined;
    ownTabletShared: boolean | undefined = undefined;
    ownTabletUninterrupted: boolean | undefined = undefined;
    ownLaptop: boolean | undefined = undefined;
    ownLaptopShared: boolean | undefined = undefined;
    ownLaptopUninterrupted: boolean | undefined = undefined;
    ownSmartphone: boolean | undefined = undefined;
    ownSmartphoneCanInstallZoom: boolean | undefined = undefined;
    ownDesktop: boolean | undefined = undefined;
    ownDesktopShared: boolean | undefined = undefined;
    ownDesktopUninterrupted: boolean | undefined = undefined;

    accessToInternet: boolean | undefined = undefined;
    accessToInternetHomeInternet: boolean | undefined = undefined;
    homeInternetDataLimit: boolean | undefined = undefined;
    homeInternetDataLimitValue: string | undefined = undefined;

    accessToInternetMobileInternet: boolean | undefined = undefined;
    mobileInternetDataLimitValue: string | undefined = undefined;

    homeWorkingLocation: boolean | undefined = undefined;
    homeWorkingLocationQuiet: boolean | undefined = undefined;
    homeWorkingLocationOnline: boolean | undefined = undefined;

    homeWorkingLocationAlternative: boolean | undefined = undefined;
    homeWorkingLocationAlternativeQuiet: boolean | undefined = undefined;
    homeWorkingLocationAlternativeOnline: boolean | undefined = undefined;

    homeWorkingCareResponsibilities: boolean | undefined = undefined;
    homeWorkingConcerns: boolean | undefined = undefined;

    transportPublicTransport: boolean = false;
    transportWalk: boolean = false;
    transportBike: boolean = false;
    transportMotorBike: boolean = false;
    transportOwnVehicle: boolean = false;
    transportCarShare: boolean = false;

    covidHighRisk: boolean | undefined = undefined;
    covidHighRiskFamily: boolean | undefined = undefined;

    photo: File | undefined = undefined;
    photoConditionsAccepted: boolean | undefined = undefined;
    photoMarketingPurposes: boolean | undefined = undefined;


    privacyNoticeAccepted: boolean | undefined = undefined;
    allowESALearningOpportunities: boolean | undefined = undefined;
    allowESAResearch: boolean | undefined = undefined;
    allowESAContactByPost: boolean | undefined = undefined;
    allowESAContactByTelephone: boolean | undefined = undefined;
    allowESAContactByEmail: boolean | undefined = undefined;
    allowMarketing: boolean | undefined = undefined;
    allowSocialMedia: boolean | undefined = undefined;
    allowPhone: boolean | undefined = undefined;
    allowPost: boolean | undefined = undefined;
    allowEmail: boolean | undefined = undefined;

    enrolmentConfirmed: boolean | undefined = undefined;
    enrolmentConfirmedFirstName: string | undefined = undefined;
    enrolmentConfirmedLastName: string | undefined = undefined;
    signature: string = '';

    enrolmentParentConfirmed: boolean | undefined = undefined;
    enrolmentParentConfirmedFirstName: string | undefined = undefined;
    enrolmentParentConfirmedLastName: string | undefined = undefined;
    enrolmentParentConfirmedRelationship: number | undefined = undefined;
    signatureParent: string = '';

    extraLanguages: string = '';

    parentContactRelationship: number | undefined = undefined;
    parent2ContactRelationship: number | undefined = undefined;

    studentId: number | undefined = undefined;

    hEQualTitle: string = '';

    lrsAccepted: boolean | undefined = undefined;
} 